
import { allMediaMutedSelector } from "../../app/recipePage/recipePage.slice";
import { useAppSelector } from "../../app/store/hooks";
import { Mute, Unmute } from "../../utils/iconRefs/recipeStepsIcons";
import styles from "./mediaPlayer.module.css";

const ToggleSoundIcon = () => {
    const allMediaMuted = useAppSelector(allMediaMutedSelector);

    return (
        <div className={styles.sound_icon} id="toggle-media-sound" >
            {allMediaMuted ? <Mute /> : <Unmute />}
        </div>
    )
}

export default ToggleSoundIcon;